import _defineProperty from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children"],
    _excluded2 = ["children"],
    _excluded3 = ["children"],
    _excluded4 = ["children"],
    _excluded5 = ["children"],
    _excluded6 = ["children"],
    _excluded7 = ["children"],
    _excluded8 = ["children"],
    _excluded9 = ["children"],
    _excluded10 = ["children"],
    _excluded11 = ["children"],
    _excluded12 = ["children"],
    _excluded13 = ["children"],
    _excluded14 = ["children"],
    _excluded15 = ["children"],
    _excluded16 = ["children"],
    _excluded17 = ["children"],
    _excluded18 = ["children"],
    _excluded19 = ["children"],
    _excluded20 = ["children"],
    _excluded21 = ["children"],
    _excluded22 = ["children"],
    _excluded23 = ["children"],
    _excluded24 = ["children"],
    _excluded25 = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import "../index.js";
import { toNativeProps } from "./common/utils.js";
/** @type { import("react").HTMLElement } */

var MediaChromeButton = React.forwardRef(function (_ref, ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? [] : _ref$children,
      props = _objectWithoutProperties(_ref, _excluded);

  return React.createElement('media-chrome-button', toNativeProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })), children);
});
export { MediaChromeButton };
/** @type { import("react").HTMLElement } */

var MediaAirplayButton = React.forwardRef(function (_ref2, ref) {
  var _ref2$children = _ref2.children,
      children = _ref2$children === void 0 ? [] : _ref2$children,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return React.createElement('media-airplay-button', toNativeProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })), children);
});
export { MediaAirplayButton };
/** @type { import("react").HTMLElement } */

var MediaCastButton = React.forwardRef(function (_ref3, ref) {
  var _ref3$children = _ref3.children,
      children = _ref3$children === void 0 ? [] : _ref3$children,
      props = _objectWithoutProperties(_ref3, _excluded3);

  return React.createElement('media-cast-button', toNativeProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })), children);
});
export { MediaCastButton };
/** @type { import("react").HTMLElement } */

var MediaGestureReceiver = React.forwardRef(function (_ref4, ref) {
  var _ref4$children = _ref4.children,
      children = _ref4$children === void 0 ? [] : _ref4$children,
      props = _objectWithoutProperties(_ref4, _excluded4);

  return React.createElement('media-gesture-receiver', toNativeProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })), children);
});
export { MediaGestureReceiver };
/** @type { import("react").HTMLElement } */

var MediaController = React.forwardRef(function (_ref5, ref) {
  var _ref5$children = _ref5.children,
      children = _ref5$children === void 0 ? [] : _ref5$children,
      props = _objectWithoutProperties(_ref5, _excluded5);

  return React.createElement('media-controller', toNativeProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })), children);
});
export { MediaController };
/** @type { import("react").HTMLElement } */

var MediaChromeRange = React.forwardRef(function (_ref6, ref) {
  var _ref6$children = _ref6.children,
      children = _ref6$children === void 0 ? [] : _ref6$children,
      props = _objectWithoutProperties(_ref6, _excluded6);

  return React.createElement('media-chrome-range', toNativeProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })), children);
});
export { MediaChromeRange };
/** @type { import("react").HTMLElement } */

var MediaControlBar = React.forwardRef(function (_ref7, ref) {
  var _ref7$children = _ref7.children,
      children = _ref7$children === void 0 ? [] : _ref7$children,
      props = _objectWithoutProperties(_ref7, _excluded7);

  return React.createElement('media-control-bar', toNativeProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })), children);
});
export { MediaControlBar };
/** @type { import("react").HTMLElement } */

var MediaTextDisplay = React.forwardRef(function (_ref8, ref) {
  var _ref8$children = _ref8.children,
      children = _ref8$children === void 0 ? [] : _ref8$children,
      props = _objectWithoutProperties(_ref8, _excluded8);

  return React.createElement('media-text-display', toNativeProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })), children);
});
export { MediaTextDisplay };
/** @type { import("react").HTMLElement } */

var MediaDurationDisplay = React.forwardRef(function (_ref9, ref) {
  var _ref9$children = _ref9.children,
      children = _ref9$children === void 0 ? [] : _ref9$children,
      props = _objectWithoutProperties(_ref9, _excluded9);

  return React.createElement('media-duration-display', toNativeProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })), children);
});
export { MediaDurationDisplay };
/** @type { import("react").HTMLElement } */

var MediaTimeDisplay = React.forwardRef(function (_ref10, ref) {
  var _ref10$children = _ref10.children,
      children = _ref10$children === void 0 ? [] : _ref10$children,
      props = _objectWithoutProperties(_ref10, _excluded10);

  return React.createElement('media-time-display', toNativeProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })), children);
});
export { MediaTimeDisplay };
/** @type { import("react").HTMLElement } */

var MediaCaptionsButton = React.forwardRef(function (_ref11, ref) {
  var _ref11$children = _ref11.children,
      children = _ref11$children === void 0 ? [] : _ref11$children,
      props = _objectWithoutProperties(_ref11, _excluded11);

  return React.createElement('media-captions-button', toNativeProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })), children);
});
export { MediaCaptionsButton };
/** @type { import("react").HTMLElement } */

var MediaSeekForwardButton = React.forwardRef(function (_ref12, ref) {
  var _ref12$children = _ref12.children,
      children = _ref12$children === void 0 ? [] : _ref12$children,
      props = _objectWithoutProperties(_ref12, _excluded12);

  return React.createElement('media-seek-forward-button', toNativeProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })), children);
});
export { MediaSeekForwardButton };
/** @type { import("react").HTMLElement } */

var MediaFullscreenButton = React.forwardRef(function (_ref13, ref) {
  var _ref13$children = _ref13.children,
      children = _ref13$children === void 0 ? [] : _ref13$children,
      props = _objectWithoutProperties(_ref13, _excluded13);

  return React.createElement('media-fullscreen-button', toNativeProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })), children);
});
export { MediaFullscreenButton };
/** @type { import("react").HTMLElement } */

var MediaLiveButton = React.forwardRef(function (_ref14, ref) {
  var _ref14$children = _ref14.children,
      children = _ref14$children === void 0 ? [] : _ref14$children,
      props = _objectWithoutProperties(_ref14, _excluded14);

  return React.createElement('media-live-button', toNativeProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })), children);
});
export { MediaLiveButton };
/** @type { import("react").HTMLElement } */

var MediaMuteButton = React.forwardRef(function (_ref15, ref) {
  var _ref15$children = _ref15.children,
      children = _ref15$children === void 0 ? [] : _ref15$children,
      props = _objectWithoutProperties(_ref15, _excluded15);

  return React.createElement('media-mute-button', toNativeProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })), children);
});
export { MediaMuteButton };
/** @type { import("react").HTMLElement } */

var MediaPipButton = React.forwardRef(function (_ref16, ref) {
  var _ref16$children = _ref16.children,
      children = _ref16$children === void 0 ? [] : _ref16$children,
      props = _objectWithoutProperties(_ref16, _excluded16);

  return React.createElement('media-pip-button', toNativeProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })), children);
});
export { MediaPipButton };
/** @type { import("react").HTMLElement } */

var MediaPlayButton = React.forwardRef(function (_ref17, ref) {
  var _ref17$children = _ref17.children,
      children = _ref17$children === void 0 ? [] : _ref17$children,
      props = _objectWithoutProperties(_ref17, _excluded17);

  return React.createElement('media-play-button', toNativeProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })), children);
});
export { MediaPlayButton };
/** @type { import("react").HTMLElement } */

var MediaPlaybackRateButton = React.forwardRef(function (_ref18, ref) {
  var _ref18$children = _ref18.children,
      children = _ref18$children === void 0 ? [] : _ref18$children,
      props = _objectWithoutProperties(_ref18, _excluded18);

  return React.createElement('media-playback-rate-button', toNativeProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })), children);
});
export { MediaPlaybackRateButton };
/** @type { import("react").HTMLElement } */

var MediaPosterImage = React.forwardRef(function (_ref19, ref) {
  var _ref19$children = _ref19.children,
      children = _ref19$children === void 0 ? [] : _ref19$children,
      props = _objectWithoutProperties(_ref19, _excluded19);

  return React.createElement('media-poster-image', toNativeProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })), children);
});
export { MediaPosterImage };
/** @type { import("react").HTMLElement } */

var MediaSeekBackwardButton = React.forwardRef(function (_ref20, ref) {
  var _ref20$children = _ref20.children,
      children = _ref20$children === void 0 ? [] : _ref20$children,
      props = _objectWithoutProperties(_ref20, _excluded20);

  return React.createElement('media-seek-backward-button', toNativeProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })), children);
});
export { MediaSeekBackwardButton };
/** @type { import("react").HTMLElement } */

var MediaPreviewTimeDisplay = React.forwardRef(function (_ref21, ref) {
  var _ref21$children = _ref21.children,
      children = _ref21$children === void 0 ? [] : _ref21$children,
      props = _objectWithoutProperties(_ref21, _excluded21);

  return React.createElement('media-preview-time-display', toNativeProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })), children);
});
export { MediaPreviewTimeDisplay };
/** @type { import("react").HTMLElement } */

var MediaPreviewThumbnail = React.forwardRef(function (_ref22, ref) {
  var _ref22$children = _ref22.children,
      children = _ref22$children === void 0 ? [] : _ref22$children,
      props = _objectWithoutProperties(_ref22, _excluded22);

  return React.createElement('media-preview-thumbnail', toNativeProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })), children);
});
export { MediaPreviewThumbnail };
/** @type { import("react").HTMLElement } */

var MediaTimeRange = React.forwardRef(function (_ref23, ref) {
  var _ref23$children = _ref23.children,
      children = _ref23$children === void 0 ? [] : _ref23$children,
      props = _objectWithoutProperties(_ref23, _excluded23);

  return React.createElement('media-time-range', toNativeProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })), children);
});
export { MediaTimeRange };
/** @type { import("react").HTMLElement } */

var MediaLoadingIndicator = React.forwardRef(function (_ref24, ref) {
  var _ref24$children = _ref24.children,
      children = _ref24$children === void 0 ? [] : _ref24$children,
      props = _objectWithoutProperties(_ref24, _excluded24);

  return React.createElement('media-loading-indicator', toNativeProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })), children);
});
export { MediaLoadingIndicator };
/** @type { import("react").HTMLElement } */

var MediaVolumeRange = React.forwardRef(function (_ref25, ref) {
  var _ref25$children = _ref25.children,
      children = _ref25$children === void 0 ? [] : _ref25$children,
      props = _objectWithoutProperties(_ref25, _excluded25);

  return React.createElement('media-volume-range', toNativeProps(_objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  })), children);
});
export { MediaVolumeRange };